"use client";

import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from "next-themes";

/**
 * Theme provider — sets `class="dark"` on <html> via next-themes.
 * Pairs with globals.css HSL tokens. `attribute="class"` is the shadcn default.
 *
 * AC 1.4: persisted in localStorage (key `theme`), no flash on load.
 */
export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
